import React, {Fragment, ReactElement, useEffect, useState} from "react"
import {observer} from "mobx-react-lite"
import {Button} from "antd"
import classNames from "classnames"
import dayjs from "dayjs"
import {AxiosResponse} from "axios"
import {mark, TUserTrack} from "@ui/api/track"
import {useStore} from "@ui/stores"
import Loader from "@ui/components/common/Loader"
import EditIcon from "@ui/icons/common/Edit"
import LeftIcon from "@ui/icons/common/Left"
import AimIcon from "@ui/icons/common/Aim"
import BookmarkIcon from "@ui/icons/track/Bookmark"
import BookmarkOffIcon from "@ui/icons/track/BookmarkOff"
import Eye from "@ui/icons/track/Eye"
import EyeOff from "@ui/icons/track/EyeOff"
import SwipePanel from "../common/SwipePanel"
import {TrackPage, TTrackPageProps} from "./"

const View = ({notifyError, goto, close, param, isShow}: TTrackPageProps): ReactElement => {
	const {route: routeStore} = useStore()
	const [route, setRoute] = useState<TUserTrack>(param)
  const [loading, setLoading] = useState(false)

	useEffect(() => {
    if (isShow) {
      if (!routeStore.isDisplay(route.id)) routeStore.show(route.id)
      else routeStore.to(route.id)
    }
	}, [isShow])

	const handleClose = () => {
    if (!routeStore.isDisplay(route.id)) routeStore.hide(route.id)
    routeStore.hideAll()
    routeStore.filter.clear()
    routeStore.changeState({reload: true})
    close()
    goto(TrackPage.List)
	}

	const handleBack = () => {
		goto(TrackPage.List)
		if (!routeStore.isDisplay(route.id)) routeStore.hide(route.id)
	}

	const handleEdit = () => {
		goto(TrackPage.Save, route)
	}

	const handleMark = () => {
    setLoading(true)
    mark(route.id)
      .then((data) => {
        setRoute(prev => ({...prev, ...data}))
        routeStore.update(route.id, data)
      })
      .catch((error: AxiosResponse) => notifyError("track.view.route.mark.error", error))
      .finally(() => setLoading(false))
  }

	const handleVisible = () => routeStore.toggle(route.id)

	const handleCenter = () => routeStore.to(route.id)

	return isShow
      ? (<SwipePanel
        onClose={handleClose}
        onSwipe={close}
        className="view"
        header={<Button className="button-back" icon={<LeftIcon/>} onClick={handleBack} />}
      >
        <Fragment>
          {loading && <Loader />}
          <div className="route">
            <div className="color-container">
              <span className={classNames("track-list-color", `color-${route.color || 1}`)}></span>
            </div>
            <div className="route-data">
              <div className="list-header-text">{route.name}</div>
              <div className="list-text ">{dayjs(route.end).format('DD.MM.YYYY HH:mm')}</div>
            </div>
            <div className="actions">
              <Button icon={<EditIcon/>} onClick={handleEdit} type="text"/>
            </div>
          </div>
          <div className="buttons">
            <Button
              icon={<AimIcon/>}
              onClick={handleCenter}
            />
            <Button
              icon={route.favorite ? <BookmarkIcon/> : <BookmarkOffIcon/>}
              onClick={handleMark}
            />
            <Button
              icon={routeStore.isDisplay(route.id) ? <Eye/> : <EyeOff/>}
              onClick={handleVisible}
            />
          </div>
        </Fragment>
      </SwipePanel>)
    : (<></>)
}

export default observer(View)
